<template>
  <b-modal title="Detalhes do Relatório de Inspeção" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Material:" label-for="material" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="material" v-model="template.material" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Resultado:" label-for="resultado" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="resultado" v-model="template.resultado" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Documento:" label-for="documento" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.documento">
              <b-form-select-option v-for="documento of getDocumentos" v-bind:key="documento.id" :value="documento"
                >{{ documento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Inspetor:" label-for="inspetor" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Imagens:" label-cols-sm="3" label-align-sm="right">
            <b-form-file
              type="file"
              class="text-left"
              v-model="arquivo"
              placeholder="Solte as fotos da imagem .jpg"
              accept=".jpg"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-cols-sm="2" label="Observação:" label-align-sm="center">
            <b-form-textarea v-model="template.observacao" rows="12"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <template-ri-modal ref="templateInspecao" @loadTemplate="loadTemplate($event)" />

    <template #modal-footer>
      <b-button variant="info" @click="templates()">Templates</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useClienteStore } from "@/stores/ClienteStore";
import { useDocumentoStore } from "@/stores/DocumentoStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import Files from "@/http/files";
import RelatorioInspecao from "@/models_reports/RelatorioInspecao";
import InspecaoTemplateModal from "@/components/modals/template/InspecaoTemplateModal";

export default {
  name: "ModalDeTemplateRI",

  components: {
    "template-ri-modal": InspecaoTemplateModal,
  },

  data() {
    return {
      show: false,
      files: new Files(this.$http),
      template: new RelatorioInspecao(),
      arquivo: null,
    };
  },

  watch: {
    arquivo: function (newValue) {
      this.$emit("loadImagemExtra", newValue);
    },
  },

  methods: {
    templates() {
      this.$refs.templateInspecao.call();
    },

    loadTemplate(template) {
      let obs = template.observacao;
      obs = obs.replaceAll(':', ':\n');
      obs = obs.replaceAll(';', ';\n')
      this.template.observacao = obs;
    },

    call(ri) {
      this.show = !this.show;
      this.template = ri;
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();
    const documentoStore = useDocumentoStore();
    const { getDocumentos } = storeToRefs(documentoStore);
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      clienteStore,
      documentoStore,
      getDocumentos,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
